import moment from 'moment';
import 'moment-duration-format';
import { ColorService } from 'ui-components/services/color-service';

const SECONDS = 'second';
const MINUTES = 'minute';
const HOURS = 'hour';
const DAYS = 'day';

const MIN_DAYS_DURATION = 3;

const mainAgeProps = {
  style: 'unit',
  unitDisplay: 'short',
};

export const getAge = (startDateTime, endDateTime) => {
  const modifiedMoment = moment.utc(startDateTime);
  const duration = moment.duration(moment(endDateTime).diff(modifiedMoment));

  if (duration < 0 && endDateTime != null) {
    return moment.duration(0);
  }
  return duration;
};

export const getAgeAsHours = (startDateTime, endDateTime) => {
  return Math.floor(getAge(startDateTime, endDateTime).asHours());
};

export const getAgeColor = (startDateTime, endDateTime) => {
  const maxHours = 48;
  const cappedHours = Math.min(getAgeAsHours(startDateTime, endDateTime), maxHours);
  const oldColor = ColorService.hexToIntColor(ColorService.getLessColor('red-650'));
  const newColor = ColorService.hexToIntColor(ColorService.getLessColor('green-500'));
  const oldNewPercentage = cappedHours / maxHours;
  const oldColorPercentage = oldNewPercentage;
  const newColorPercentage = 1 - oldNewPercentage;
  const ageColor = {
    red: Math.round(oldColorPercentage * oldColor.red + newColorPercentage * newColor.red),
    blue: Math.round(oldColorPercentage * oldColor.blue + newColorPercentage * newColor.blue),
    green: Math.round(oldColorPercentage * oldColor.green + newColorPercentage * newColor.green),
  };
  return `#${ageColor.red.toString(16)}${ageColor.green.toString(16)}${ageColor.blue.toString(16)}`.toUpperCase();
};

export const buildAgeProps = (startDateTime, endDateTime) => {
  const momentDuration = getAge(startDateTime, endDateTime);
  if (!startDateTime) {
    return {
      ...mainAgeProps,
      unit: SECONDS,
      value: 0,
    };
  }

  const duration = moment.duration(momentDuration);
  const ageInSeconds = Math.floor(duration.asSeconds());
  const ageInMinutes = Math.floor(duration.asMinutes());
  const ageInHours = Math.floor(duration.asHours());
  const ageInDays = Math.floor(duration.asDays());

  if (!ageInMinutes) {
    return {
      ...mainAgeProps,
      unit: SECONDS,
      value: ageInSeconds,
    };
  }
  if (!ageInHours) {
    return {
      ...mainAgeProps,
      unit: MINUTES,
      value: ageInMinutes,
    };
  }
  if (Math.abs(ageInDays) < MIN_DAYS_DURATION) {
    return {
      ...mainAgeProps,
      unit: HOURS,
      value: ageInHours,
    };
  }

  return {
    ...mainAgeProps,
    unit: DAYS,
    value: ageInDays,
  };
};
